<template>
  <el-dialog
    :title="model.id > 1 ? '编辑采购单' : '新采购单'"
    :visible.sync="visible"
    width="960px"
    @close="$emit('update:show', false)"
    @opened="opened"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="100px"
      size="small"
    >
      <el-form-item style="position: relative" label="订单号">
        <el-select
          size="small"
          class="fix-width"
          filterable
          placeholder="请选择"
          :disabled="fixedOrder || model.id > 0"
          v-model="model.customer_order_id"
        >
          <el-option
            v-for="item in orders"
            :key="item.id"
            :label="item.number"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="申请人">
        <el-select size="small" class="fix-width" placeholder="请选择" v-model="model.creator_id">
          <el-option
            v-for="item in users"
            :key="item.id"
            :label="item.name"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>
      </el-form-item>-->

      <el-form-item class="list" label="产品明细" prop="items">
        <el-table
          v-if="model.items && model.items.length > 0"
          :data="model.items"
          style="margin-bottom: 10px"
        >
          <el-table-column label="对象" width="60px">
            <template slot-scope="scope">{{
              scope.row.category == 1 ? '零件' : '设备'
            }}</template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="item.name"
            label="名称"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="item.part_number"
            label="件号"
            width="120px"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="item.machine_type"
            label="机型"
            width="120px"
          ></el-table-column>
          <!-- <el-table-column align="center" prop="item.price" label="单价" width="120px">
            <template slot-scope="scope">
              {{
              scope.row.item.price.toFixed(2)
              }}
            </template>
          </el-table-column>-->
          <el-table-column align="center" label="单价" width="120">
            <template slot-scope="scope">
              <el-input-number
                :controls="false"
                style="width: 80px"
                size="mini"
                v-model="scope.row.price"
                :precision="2"
                :min="0"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column align="center" label="数量" width="120px">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.count"
                style="width: 100px"
                size="mini"
                type="number"
                :min="1"
                :max="1000"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column width="50">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="text-danger"
                @click="removeItem(scope.$index)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-button
            v-if="!order"
            size="small"
            icon="el-icon-plus"
            type="primary"
            @click="itemSelectorVisible = true"
            >添加</el-button
          >
          <el-popover
            v-else
            placement="right-start"
            trigger="click"
            v-model="orderItemVisbile"
          >
            <div class="order-items" v-if="order">
              <div class="header">
                <h2>采购清单</h2>
              </div>
              <ul class="item-list" v-if="orderItems.length > 0">
                <template v-for="(item, index) in orderItems">
                  <li
                    class="flex-row-between"
                    @click="addPurchaseItem(item, index)"
                  >
                    <span>{{ item.name }}</span>
                    <span>x{{ item.count }}</span>
                  </li>
                </template>
              </ul>
              <div v-else class="text-info-12 mt-10">
                订单产品已全部加入采购单
              </div>
            </div>
            <el-button
              class="toggle-button"
              type="primary"
              icon="el-icon-view"
              size="mini"
              slot="reference"
              plain
              >订单清单</el-button
            >
          </el-popover>
        </div>
      </el-form-item>

      <el-form-item label="备注">
        <el-input
          v-model="model.remark"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 8 }"
          class="fix-width"
          size="small"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
    <item-device-selector
      :show.sync="itemSelectorVisible"
      :selection="model.items"
      :inner="true"
      :multiple="true"
      @selected="doneSelectedItems"
    ></item-device-selector>
  </el-dialog>
</template>

<script>
import ItemDeviceSelector from '@/components/item_selector'
import {
  createPurchaseOrder,
  updatePurchaseOrder,
  customerOrderList,
  customerOrderDetail,
  userList,
} from '@/service/getData'
import { clone } from '@/util'

export default {
  components: {
    ItemDeviceSelector,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    purchaseItems: {
      type: Array,
      default: () => [],
    },
    fixedOrder: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
        this.order = null
      }
    },
    'model.customer_order_id': 'getOrderInfo',
  },
  computed: {
    orderItems() {
      if (this.purchaseItems.length) {
        return this.purchaseItems
      }
      var items = []
      this.order.order_info.products.map((product) => {
        let item = clone(product.item)
        item.count = product.count
        items.push(item)
      })
      this.order.order_info.devices.map((device) => {
        device.items.map((item) => {
          let oitem = clone(item.item)
          oitem.count = item.count
          items.push(oitem)
        })
      })

      items = items.filter((i) => {
        return !this.model.items.some((j) => i.id == j.item_id)
      })

      if (items.length == 0) {
        this.orderItemVisbile = false
      }
      return items
    },
  },
  created() {
    this.initData()
  },
  data() {
    return {
      visible: this.show,
      itemSelectorVisible: false,
      orderItemVisbile: false,
      users: [],
      order: null,
      orders: [],
      rules: {
        customer_order_id: [{ required: true, message: '请选择订单号' }],
        items: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个产品',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    async initData() {
      const pagination = { page: 0, size: 1000, resource_not_filter: true }

      let resUser = await userList(pagination)
      let resOrder = await customerOrderList(pagination)

      this.users = resUser.data.list
      this.orders = resOrder.data.list
    },

    async getOrderInfo() {
      if (this.model.customer_order_id) {
        let res = await customerOrderDetail(this.model.customer_order_id)
        if (res.code == 0) {
          this.order = res.data
          this.orderItemVisbile = true
        }
      }
    },
    opened() {
      if (!this.order && this.model.customer_order_id > 0) {
        this.getOrderInfo()
      }
    },
    removeItem(index) {
      this.model.items.splice(index, 1)
    },
    doneSelectedItems(items) {
      items = items.map((item) => {
        return {
          count: 1,
          price: item.price,
          item_id: item.id,
          item: item,
        }
      })
      this.model.items = this.model.items.concat(items)
      this.$refs.form.validateField('items')
    },
    addPurchaseItem(item, index) {
      let pitem = {
        item_id: item.id,
        price: item.price,
        count: item.count,
        item: item,
      }
      this.model.items.push(pitem)
    },
    formatData(obj) {
      const keys = ['creator_id', 'customer_order_id']
      for (let key in obj) {
        if (keys.indexOf(key) != -1 && obj[key] == '') {
          obj[key] = 0
        }
      }
      return obj
    },

    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.formatData(this.model)

          if (data.id > 0) {
            let res = await updatePurchaseOrder(data)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createPurchaseOrder(data)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>
<style scoped>
.fix-width {
  width: 220px;
}
.item-list li {
  cursor: pointer;
}

.order-items h2 {
  font-size: 14px;
  color: #555;
  margin-bottom: 10px;
}

.order-items ul li {
  padding: 6px 0;
}

.order-items ul li:hover {
  background-color: #f9f9f9;
}
</style>